import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@features/auth/auth.service';
import { captureTwxPlanIntent } from '@twinnyx/core/plan/plan-intent';

/**
 * Without a session: the login, or the sign-up when twinnyx.com sent the visitor with a
 * website (`?url=`, its hero's form) or a plan (`?plan=`, its pricing). The sign-up also
 * takes existing emails (it signs them in), so a customer coming for a plan lands on it too.
 */
export const privatePagesGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const authS = inject(AuthService);

    // Kept for later either way: a logged-in customer coming for a plan is sent to pay it by the shell.
    // Only from outside: Ajustes' own `?plan=` (the plan picked there) is never an intent, or a
    // reload of Facturación would send to pay it again.
    const inSettings = state.url.startsWith('/settings');
    const entry = inSettings
        ? { plan: null, url: null, lang: null }
        : captureTwxPlanIntent(new URLSearchParams(route.queryParams).toString());
    const isLogged = authS.isUserLogged();
    if (!isLogged) {
        const wantsStart = !!route.queryParams['url'] || !!route.queryParams['plan'];
        if (wantsStart) {
            const queryParams: Record<string, string> = {};
            if (entry.url) queryParams['url'] = entry.url;
            if (entry.lang) queryParams['lang'] = entry.lang;
            if (entry.plan) queryParams['plan'] = entry.plan;
            router.navigate(['/auth/start'], { queryParams });
        } else router.navigateByUrl('/auth/login');
    }

    return isLogged;
};
